<script lang="ts">

    import { navigate } from 'svelte-navigator';
    import { fade } from 'svelte/transition';
    import { geolocation, routesService } from '../Services';
    import { delay } from '../Services/Helpers';
    import type { Coordinates } from '../global';
    import { DistanceCalculator } from '../Services/DistanceCalculator';

    const distanceThreshold = 50;

    checkGeolocationAndRedirect();

    async function checkGeolocationAndRedirect(): Promise<void> {

        try {

            //Solicitamos la geolocalización aplicando al mismo
            //tiempo un delay de 2 segundos
            const [position] = await Promise.all([geolocation.getPosition(), delay(2000)]);

            selectBestRoute(position);

        } catch (error) {

            navigate('/menu');

        }
    }

    async function selectBestRoute(userCoordinates: Coordinates): Promise<void> {

        const distanceCalculator = new DistanceCalculator();
        
        //Obtenemos todas las rutas
        const routes = await routesService.getAllRoutes();

        //Buscamos una ruta cuyo inicio esté suficientemente
        //cerca de la posición del usuario
        const bestRoute = routes.find(route => {
            const distanceToStart = distanceCalculator.calcDistance(userCoordinates, route.firstCheckpoint.coordinates);
            return distanceToStart < distanceThreshold;
        });

        if (bestRoute) {
            //Redireccionamos al usuario a la pantalla de inicio de la ruta
            navigate(`/ruta/${bestRoute.id}`);
            return;
        }

        //No hay ninguna ruta optima para comentzar
        //Redireccionamos hacia el menú
        navigate('/menu');

    }

</script>

<style>

    .load-page {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: var(--vh, 100vh);
        background-color: var(--color-primary);
    }

    .logo {
        width: 90%;
        max-width: 300px;
    }

</style>

<div class="load-page" transition:fade>

    <a href="/menu"><img class="logo" src="/images/iconos_intro.svg" alt="Rutas Saludables"></a>

</div>
